<template>
	<div>
		<ChangeController
			:visible="dataChanged"
			@close="show = false"
			@revert="revert"
			@save="save"
		/>

		<v-card>
			<v-card-text>
				<section class="mb-10">
					<h2 class="mb-4">File Attachments</h2>
					<Collection
						cols="auto"
						:collection="data.files"
						@change="dataChanged = true"
						dialogWidth="600"
						:form="$options.FileForm"
						title="File Attachment"
						breakpoints="xs12 sm3 md3 lg3 xl2"
						isFileUpload
					>
						<FileItem slot-scope="{ item }" v-bind="item" />
					</Collection>
				</section>
				<section class="mb-10">
					<h2 class="mb-4">Providers</h2>
					<TextEditor v-model="data.text" @show-change="dataChanged = true" />
				</section>
				<section>
					<h2 class="mb-4">Provider Services</h2>
					<Collection
						:collection="data.services"
						@change="dataChanged = true"
						dialogWidth="800"
						:form="$options.ServiceForm"
						title="Service"
						breakpoints="xs12 sm3 md3 lg3 xl2"
					>
						<ServiceItem slot-scope="{ item }" v-bind="item" />
					</Collection>
				</section>
				<section class="mt-10 mb-10">
					<h2 class="mb-4">Provider Network</h2>
					<h3>PRIMAR Providers</h3>
					<Collection
						:collection="data.primarProviders"
						@change="dataChanged = true"
						dialogWidth="600"
						:form="$options.CountryForm"
						title="PRIMAR Provider"
						breakpoints="xs12 sm3 md3 lg3 xl2"
					>
						<CountryItem slot-scope="item" v-bind="item" />
					</Collection>

					<h3>Other Providers</h3>
					<Collection
						:collection="data.otherProviders"
						@change="dataChanged = true"
						dialogWidth="600"
						:form="$options.CountryForm"
						title="Other Provider"
						breakpoints="xs12 sm3 md3 lg3 xl2"
					>
						<CountryItem slot-scope="item" v-bind="item" />
					</Collection>
				</section>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import TextEditor from '@/components/admin/TextEditor'
import DataMixin from '@/mixins/DataMixin'

import Collection from '@/components/admin/ItemCollection'
import ServiceItem from '@/components/n-collections/n-items/ServiceItem'
import CountryItem from '@/components/n-collections/n-items/CountryItem'
import FileItem from '@/components/n-collections/n-items/FileItem'

import ServiceForm from '@/components/dialogs/forms/ServiceForm'
import CountryForm from '@/components/dialogs/forms/CountryForm'
import FileForm from '@/components/dialogs/forms/FileForm'

export default {
	name: 'AdminProviders',
	mixins: [DataMixin],
	components: {
		TextEditor,
		Collection,
		ServiceItem,
		CountryItem,
		FileItem
	},
	ServiceForm,
	CountryForm,
	FileForm,
}
</script>

<style lang="scss" scoped>
</style>